export default (theme) => ({
    root: {
        height: '100%',
        display: 'flex',
        '@media screen and (min-width: 768px)': {
            width: '100%',
        },
    },
    frame: {
        width: 415,
        height: '100%',
        '@media screen and (max-width: 850px)': {
            display: 'none',
        },
    },
    children: {
        width: '100%',
        height: '100%',
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
});
